import script from "./Publicacao.vue?vue&type=script&setup=true&lang=js"
export * from "./Publicacao.vue?vue&type=script&setup=true&lang=js"

import "./Publicacao.vue?vue&type=style&index=0&id=6e853c1a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e853c1a"]])

export default __exports__